// 문구 안의 HH:MM:SS 시각을 HH:MM으로 줄인다.
// 과거에 DB TIME 값을 그대로 넣어 저장된 활동/티켓 이력 문구(예: "19:30:00 레슨 취소")를 화면에서 통일하기 위함.
export const stripSeconds = (text) =>
  typeof text === 'string' ? text.replace(/\b(\d{2}:\d{2}):\d{2}\b/g, '$1') : text;

// 단일 시각 값(HH:MM:SS 또는 HH:MM)을 HH:MM으로
export const hhmm = (t) => (t ? String(t).slice(0, 5) : '');
